<template>

    <div>

        <div class="row wrapper border-bottom white-bg page-heading">
            <div class="col-sm-4">
                <h2>Encuesta</h2>
                <ol class="breadcrumb">
                    <li class="active">
                        <strong>{{ estacion.estacion }}</strong>
                    </li>
                    <li>
                        <a href="#">{{ estacion.formato }}</a>
                    </li>
                </ol>
            </div>
        </div>


        <div class="row">
            <div class="col-lg-12">
                <div class="ibox float-e-margins">
                    <div class="ibox-content p-md">
                        <!-- <ingreso-full 
                            :estacion_de_servicio_id="estacion.id"
                            :preguntas="estacion.preguntas"
                            :estacion="estacion"
                        ></ingreso-full> -->

                        <listado-encuestas-protocolo></listado-encuestas-protocolo>
                        

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    
    import ListadoEncuestasProtocolo from './encuesta/ListadoEncuestasProtocolo.vue'

    export default {
        components: {
            ListadoEncuestasProtocolo
        },
        data() {
            return {
                estacion: {},
            }
        },
        methods: {
			getEstacion() {
                  this.$Progress.start();
                  axios.get('api/estaciones').then(({ data }) => (this.estacion = data.data));
                  this.$Progress.finish();
            },
		},
        mounted() {
            // console.log('Component mounted.')
			this.getEstacion();
        }
    }
</script>
